import React, {useState} from 'react';

import {SilverRightArrow, WhatsAppIcon} from '../../styles/icons';
import utility from '../../utils/Helper';
import Config from '../../utils/Configuration';
import i18nLabels from './FloatyWhatsApp.i18n';
import decorateContainer from '../../utils/DecoratedContainer';

const FloatyWhatsApp = ({intl}) => {
    const [showMainButton, setShowMainButton] = useState(true);
    return (
        <div className={`floaty-whats-app ${showMainButton ? 'show-main-button' : ''}`}>
            <div className='main-button-outer'>
                <div
                    className='main-button d-flex align-items-center'
                    onClick={() => utility.whatsAppUsNow(Config.whatsAppMessageTemplate.floatyWhatsApp)}
                >
                    <div className='text'>{intl.messages.whatsAppLabel}</div>
                    <WhatsAppIcon />
                </div>
            </div>
            <div
                className='arrow-right d-flex align-items-center justify-content-center'
                onClick={() => setShowMainButton(!showMainButton)}
            >
                <SilverRightArrow />
            </div>
            <div
                className='arrow-left d-flex align-items-center justify-content-center'
                onClick={() => setShowMainButton(!showMainButton)}
            >
                <SilverRightArrow />
            </div>
        </div>
    );
};

export default decorateContainer(FloatyWhatsApp, i18nLabels);
